import React from 'react'
import DownloadFile from '../../../../shared/component/downloadFile'
import Input from '../../../../shared/component/inputFields'

const ContractFile = () => {
  return (
    <div className='contractFile'>
      <div className='row'>
        <div className='col-lg-6 col-md-6'>
          <h2 className='title'>Contract File</h2>
          <DownloadFile bold urlDownload="/" urlView="/" title="Please download our Contract File and read it carefully" />
          <Input type="check" label="I have read the Contract File and agree to it." bold />
          <p className='hint'>you can make shipping and delivery movements with us as soon as you agree to what is mentioned in the attached contract above</p>
        </div>
        <div className='col-lg-6 col-md-6'>
          <h2 className='title'>Contract File</h2>
          <DownloadFile urlDownload="/" urlView="/" title="Please download our Contract File and read it carefully" />
          <Input type="check" label="I have read the Contract File and agree to it." checked readonly />
          <h2 className='title'>New Contract File</h2>
          <DownloadFile urlDownload="/" urlView="/" title="Please download our Contract File and read it carefully" />
          <Input type="check" label="I have read the Contract File and agree to it." />
          <p className='hint'>you can make shipping and delivery movements with us as soon as you agree to what is mentioned in the attached contract above</p>
        </div>
      </div>
      <div className='action'>
        <div className='container'>
          <button className='btn-blue'>Agree Contract</button>
        </div>
      </div>
    </div>
  )
}

export default ContractFile